module.exports = __webpack_public_path__ + "static/img/Back_btn.aa0a3767.png";